import { isMobile } from '../utils/useragent';
import { messageBoxSuccess, messageBoxError } from './message-box';

class BlogShareButton {

  public element: HTMLElement;
  public shareButton: HTMLButtonElement | null | undefined;
  public copyButton: HTMLButtonElement | null | undefined;


  cache() {
    this.element = document.querySelector('.js-m-bsb') as HTMLElement;
    this.shareButton = document.querySelector('.js-m-bsb__share-button') as HTMLButtonElement;
    this.copyButton = document.querySelector('.js-m-bsb__button--copy') as HTMLButtonElement;
  }

  bindings() {
    const { element, shareButton, copyButton } = this;

    if(shareButton) {
      shareButton.addEventListener('click', (e: MouseEvent) => {
        if(isMobile()) {
          this.handleMobileShare((e.currentTarget as HTMLElement | null)?.dataset.url);
        }else {
          element.classList.toggle('is-active');
        }
      });
    }

    if(copyButton) {
      copyButton.addEventListener('click', (e: MouseEvent) => this.handleCopy(e));
    }
  }

  handleCopy(e: MouseEvent) {
    e.preventDefault();
    navigator.clipboard.writeText((e.currentTarget as HTMLElement)?.dataset.url ?? '')
      .then(function() {
        messageBoxSuccess({
          contentDe: 'Link wurde kopiert.',
          contentEn: 'Copied link.',
        });
      }, function() {
        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Link konnte nicht kopiert werden.',
          contentEn: 'An error appeared. Could not copy link.',
        });
      });
  }

  async handleMobileShare(url: string | undefined) {
    const shareData = {
      url: url,
    };

    try {
      await navigator.share(shareData)
    } catch(err) {
      console.error(err);
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}
export default BlogShareButton;